import React, { Suspense, lazy, useState } from 'react'
import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'

// Carga los componentes de manera dinámica y especifica la importación de 'default'
const Header = lazy(
  async () =>
    await import('@/components/organisms/Header/Header').then((module) => ({
      default: module.default
    }))
)
const BannerHome = lazy(
  async () =>
    await import('@/components/templates/Home/BannerHome/BannerHome').then((module) => ({
      default: module.default
    }))
)
const ServicesTabs = lazy(
  async () =>
    await import('@/components/templates/Home/ServicesTabs/ServicesTabs').then((module) => ({
      default: module.default
    }))
)
const Services = lazy(
  async () =>
    await import('@/components/templates/Home/Services/Services').then((module) => ({
      default: module.default
    }))
)
const AboutUs = lazy(
  async () =>
    await import('@/components/templates/Home/AboutUs/AboutUs').then((module) => ({
      default: module.default
    }))
)
const WhyChoose = lazy(
  async () =>
    await import('@/components/templates/Home/WhyChoose/WhyChoose').then((module) => ({
      default: module.default
    }))
)
const WhatCharacterisesUs = lazy(
  async () =>
    await import('@/components/templates/Home/WhatCharacterisesUs/WhatCharacterisesUs').then(
      (module) => ({ default: module.default })
    )
)
const EnhanceAdvantage = lazy(
  async () =>
    await import('@/components/templates/Home/EnhanceAdvantage/EnhanceAdvantage').then(
      (module) => ({
        default: module.default
      })
    )
)
const WhatWeYourCompany = lazy(
  async () =>
    await import('@/components/templates/Home/WhatWeYourCompany/WhatWeYourCompany').then(
      (module) => ({
        default: module.default
      })
    )
)
const FormContactUs = lazy(
  async () =>
    await import('@/components/templates/Home/FormContactUs/FormContactUs').then((module) => ({
      default: module.default
    }))
)
const FrequentlyAskedQuestions = lazy(
  async () =>
    await import(
      '@/components/templates/Home/FrequentlyAskedQuestions/FrequentlyAskedQuestions'
    ).then((module) => ({ default: module.default }))
)
const Footer = lazy(
  async () =>
    await import('@/components/organisms/Footer/Footer').then((module) => ({
      default: module.default
    }))
)

export const Home: React.FC = () => {
  const buildDate = new Date().toISOString()
  const [selectedTab, setSelectedTab] = useState<string | null>(null)

  return (
    <PageWrapper
      title="Basciano Trading Corporation"
      description="Our services are focused on innovation, efficiency and security. We offer a range of services to support the growth and expansion of your business, including supplier payments, risk management and specialised financing."
      url="https://www.basciano.com"
      keywords={[
        'Basciano Trading Corporation',
        'Foreign trade operations',
        'Administrative processes',
        'Payments',
        'Optimization',
        'Simplification',
        'International trade',
        'Import/export',
        'Trade facilitation',
        'Business solutions',
        'Strategic ally',
        'Global business',
        'Customs clearance',
        'Compliance',
        'Trade finance',
        'Basciano Trading Corporation foreign trade services',
        'Simplify administrative processes in international trade',
        'Optimize payments for foreign trade transactions',
        'Trade facilitation services for businesses',
        'Best practices for global business operations',
        'Customs clearance and compliance solutions',
        'Trade finance options for international trade'
      ]}
      language="en"
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className="min-h-screen flex flex-col overflow-hidden">
          <Header />
          <main className="flex-grow">
            <section id="home">
              <BannerHome />
            </section>
            <section id="tabs">
              <ServicesTabs selectedTab={selectedTab} onSelectTab={setSelectedTab} />
            </section>
            <section id="services">
              <Services selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
            </section>
            <section id="aboutUs">
              <AboutUs />
            </section>
            <section id="whyChoose">
              <WhyChoose />
            </section>
            <section id="WhatCharacterisesUs">
              <WhatCharacterisesUs />
            </section>
            <section id="WhatCharacterisesUs">
              <EnhanceAdvantage />
            </section>
            <section id="whatWeYourCompany">
              <WhatWeYourCompany />
            </section>
            <section id="formContactUs">
              <FormContactUs />
            </section>
            <section id="frequentlyAskedQuestions">
              <FrequentlyAskedQuestions />
            </section>
          </main>
          <Footer />
        </div>
      </Suspense>
    </PageWrapper>
  )
}
